import { Flex, HStack, Text, VStack } from '@chakra-ui/react';

import { useMemo } from 'react';
import { Checkbox } from '~/components/ui/checkbox';
import { useI18nLn } from '~/hooks/store';
import { GachaDetail } from '~/types/resources/gachaDetail';

type Props = {
  gachaDetail: GachaDetail;
  isConfirmed: boolean;
  setToConfirm: (value: boolean) => void;
};

export const SelectWarning: React.FC<Props> = (props: Props) => {
  const { t } = useI18nLn();

  const isWarningTextExist = useMemo(() => {
    const text = props.gachaDetail.purchase_precaution;
    return text && text.length > 0;
  }, [props.gachaDetail.purchase_precaution]);

  if (!isWarningTextExist) {
    return null;
  }

  return (
    <VStack gap={4} w="full" justifyItems="stretch" alignItems="inherit">
      <Flex
        flexDir="column"
        borderColor="border"
        borderStyle="solid"
        justify="left"
        bgColor="blank"
        py="16px"
        px="12px"
        rowGap={2}
      >
        <Text fontSize="15px" fontWeight="bold">
          {t('pages.buy.check_warning.title')}
        </Text>
        <Text fontSize="15px" whiteSpace="pre-wrap">
          {props.gachaDetail.purchase_precaution}
        </Text>
      </Flex>
      <HStack gap={2}>
        <Checkbox
          colorScheme="green"
          size="lg"
          checked={props.isConfirmed}
          onChange={() => {
            props.setToConfirm(!props.isConfirmed);
          }}
        />
        <Text fontSize="15px">{t('pages.buy.check_warning.form_title')}</Text>
      </HStack>
    </VStack>
  );
};
